import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
//
// Copyright 2022 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
var ConfigurationSetToNull = function ConfigurationSetToNull(_ref) {
  var data = _ref.data,
    setData = _ref.setData,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 0 : _ref$paddingTop;
  var setToNullOptionChange = function setToNullOptionChange(event) {
    var newData = _objectSpread({}, data);
    if (event.target.checked) {
      newData.oldValue = newData.value;
      newData.value = "";
      newData.blankValue = true;
    } else {
      if (newData.value === "" && newData.oldValue !== "") {
        newData.value = newData.oldValue;
      }
      newData.blankValue = false;
    }
    setData(newData);
  };
  var setToNullControl = /*#__PURE__*/React.createElement(React.Fragment, null);
  if (data && data.required === false && data.hasTargetType === true) {
    setToNullControl = /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
      style: {
        display: 'table',
        width: 100
      },
      control: /*#__PURE__*/React.createElement(Checkbox, {
        style: {
          display: 'table-cell',
          paddingLeft: 0,
          paddingRight: 0
        },
        onChange: setToNullOptionChange,
        checked: data && String(data.blankValue) === "true"
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        style: {
          fontStyle: "italic",
          display: 'table-cell',
          paddingTop: 12
        }
      }, "Set to null")
    }));
  }
  return setToNullControl;
};
export default ConfigurationSetToNull;